// extracted by mini-css-extract-plugin
export default {"message-card":"MessageCard_message-card__TEt+q","img-box":"MessageCard_img-box__sR0qy","info":"MessageCard_info__nLIWl"};